<template>
  <button class="button-swiper">
    <svg
      :style="{transform: duration === 'next' ? 'rotateZ(180deg)' : 'none'}"
      width="11"
      height="17"
      viewBox="0 0 11 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.05383 8.5L9.15033 11.634C9.90444 12.3972 9.92193 13.6196 9.18996 14.4041L8.23806 15.4243C7.44446 16.2749 6.09517 16.2712 5.30613 15.4164L0.792361 10.5265C-0.264095 9.38204 -0.264094 7.61796 0.792361 6.47347L5.4832 1.39172C6.20374 0.611143 7.4088 0.53005 8.22742 1.20705L9.31513 2.1066C10.2204 2.85526 10.2885 4.21922 9.46237 5.05436L6.05383 8.5Z"
        fill="#3E3E3E"
      />
    </svg>
  </button>
</template>

<script setup>
const props = defineProps({
  duration: {
    type: String,
    default: 'prev'
  }
});
</script>

<style scoped>
.button-swiper {
  background-color: rgba(255,255,255, .5);
  min-width: 45px;
  min-height: 45px;
  border-radius: 50%;
  box-shadow: 0 2px 25px rgb(0 0 0 / 15%);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 11px 17px;
  border: none;
  cursor: pointer;
  transition: transform .2s ease;
  will-change: transform;
}
.button-swiper:active {
  transform: scale(.95);
}
@media (max-width: 1279px) {
  .button-swiper {
    min-height: 40px;
    min-width: 40px;
  }
}
@media (max-width: 768px) {
  .button-swiper {
    display: none;
  }
}
</style>
